const normalizeStatus = (status) =>
  typeof status === "string" ? status.trim() : "";

const normalizeId = (value) => String(value ?? "").trim();

const isActiveClient = (client) =>
  normalizeStatus(client?.status) === "active-string";

export const isPendingInvitationClient = (client) => {
  if (!client || typeof client !== "object") {
    return false;
  }

  return client.usePendingBlocksPath === true && !isActiveClient(client);
};

export const isVisibleInSideMenu = (client) => {
  if (!client || typeof client !== "object") {
    return false;
  }

  return isActiveClient(client) || isPendingInvitationClient(client);
};

export const filterVisibleSideMenuClients = (clients) => {
  if (!Array.isArray(clients) || clients.length === 0) {
    return [];
  }

  return clients.filter((client) => isVisibleInSideMenu(client));
};

export const isBlockCopyEligibleClient = (client) => {
  if (!client || typeof client !== "object") {
    return false;
  }

  if (isActiveClient(client)) {
    return true;
  }

  return (
    client.usePendingBlocksPath === true &&
    normalizeId(client.pendingUserId) !== ""
  );
};

export const filterBlockCopyEligibleClients = (clients) => {
  if (!Array.isArray(clients) || clients.length === 0) {
    return [];
  }

  return clients.filter((client) => isBlockCopyEligibleClient(client));
};
